
import {tipsSearch} from '../api/common'
const global = require('../../../static/global')
import {getIndex} from '../../TASMini/api/person'
import { setToken } from "../../utils/auth"
  import Cookies from 'js-cookie'
export  function afterLogin(loginRes,systemType){
  Cookies.set('loginRes', {loginRes:loginRes,systemType:systemType}, {domain:global.cookiePath})
  let that = this;
  if(systemType == 1){
      
      setToken(loginRes.data.token)
      Cookies.set('token', loginRes.data.token, {domain:global.cookiePath})
      Cookies.set('app.token', loginRes.data.token, {domain:global.cookiePath})
      Cookies.set('logindata', loginRes.data, {domain:global.cookiePath})
      if(loginRes.data.auditStatus==40&&loginRes.data.launch==false){
        window.location.href = global.srmPath + "/#/sale-area"
        return
      }
      if(loginRes.data.auditStatus!=40){
        tipsSearch({systemType:systemType}).then(res=>{
          console.log(res,'---');
          if(res.code==200){
            if(res.data.status==1 ||  res.data.status==2 || res.data.status==3){
              console.log(this,'-0-0-0');
              that.$confirm({
                title:'异常提示',
                content:res.data.tips,
                onOk:()=>{
                  window.location.href = global.srmPath + "/#/settle-list"
                }
              })
            }else{
              window.location.href = global.srmPath + "/#/settle-list"
            }
          }else{
            this.$message.error(res.message?res.message:'异常提示接口报错')
          }  
        })
        return
      }else if(!loginRes.data.launch){
        window.location.href = global.srmPath + "/#/sale-area"
      }else{
        getIndexFun(1)
      }

    }else if(systemType == 2){
      localStorage.setItem('initStore',loginRes.data.initStore)
      Cookies.set('token', loginRes.data.token, {domain:global.cookiePath})
      Cookies.set('app.token_TAS', loginRes.data.token, {domain:global.cookiePath})
      Cookies.set('logindata_TAS', loginRes.data, {domain:global.cookiePath})
      Cookies.set('initStore', loginRes.data.initStore, {domain:loginRes.data.initStore})

      if(loginRes.data.auditStatus!=40 ){
        tipsSearch({systemType:systemType}).then(res=>{
          console.log(res,'---');
          if(res.code==200){
            if(res.data.status==1 ||  res.data.status==2 || res.data.status==3){
              this.$confirm({
                title:'异常提示',
                content:res.data.tips,
                class:'confirmBtn',
                onOk:()=>{
                  window.location.href = global.tasPath + "/#/settled-list"
                }
              })
            }else{
              window.location.href = global.tasPath + "/#/settled-list"
            }
          }else{
            this.$message.error(res.message?res.message:'异常提示接口报错')
          }  
        })
        // window.location.href = global.tasPath + "/#/settled-list"
      }else if(!loginRes.data.initStore){
        window.location.href = global.tasPath + "/#/shopsmart?firstLogin=true"
      }else{
          getIndexFun(2)
      }
    }
    
}

export function getIndexFun(x,reload){
    console.log(x,',----------')

    getIndex(x).then(res=>{
    if(res.code==200){
      let url  = res.data[0].url
      console.log('默认的登录url',url,url.indexOf('/'));
      if(url.indexOf('/')==-1){
        this.$message.info('默认跳转的页面地址存在异常，请联系管理员')
        return 
      }
      if(x==1){
        window.location.href = global.srmPath + "/#"+url
      }else{
        window.location.href = global.tasPath + "/#"+url
      }
      if(reload){
        window.location.reload()
      }
    }else{
      this.$message.error(res.message)
    }
    })
  }


// WEBPACK FOOTER //
// ./src/Master/utils/commonLogin.js